import {
    Box,
    Button,
    Dialog,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import youtubeLogo from "./../../../assets/images/youtube-logo.png";


const SelectDownloadMethod = (props: any) => {
    const navigate = useNavigate()
    const { open, setOpen, processId } = props;
    const [isLoading, setLoading] = useState(false);

    const handleClose = () => {
        navigate(`/template/download/${processId}`);
        setOpen(false);
    };

    const onOk = () => {
        setLoading(true);
        navigate(`/Signdashboard/${processId}`)
        setOpen(false);
    };



    return (
        <Box height={"300px"}>
            <Dialog
                sx={{ alignItems: "flex-start", maxHeight: 600 }}
                fullWidth
                maxWidth="sm"
                open={open}
                PaperProps={{
                    elevation: 0,
                    sx: { display: "flex", flexDirection: "column" },
                }}
            >
                <Box p={2}>
                    <Box>
                        <Typography variant="body1" color="textSecondary" sx={{ fontWeight: "800", color: "black" }}>
                            Do You Want to Sign the Document?
                        </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                        {/* YouTube Logo Button (left) */}
                        <Button>
                            <a
                                href="https://youtu.be/6_rRsC2w8ms"
                                target="_blank"
                                rel="Signing the Documents in Quantum"
                            >
                                <img
                                    src={youtubeLogo}
                                    alt="YouTube logo"
                                    style={{
                                        width: '28px',
                                        height: '24px',
                                        cursor: 'pointer',
                                        marginTop: -3,
                                    }}
                                />
                            </a>
                        </Button>

                        {/* Yes / No Buttons (right) */}
                        <Box display="flex" gap={2}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                sx={{ minWidth: 70 }}
                                size="small"
                                onClick={onOk}
                                disabled={isLoading}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{ minWidth: 70 }}
                                size="small"
                                color="secondary"
                                onClick={handleClose}
                            >
                                No
                            </Button>
                        </Box>
                    </Box>

                </Box>
            </Dialog>
        </Box>
    );
};

export default SelectDownloadMethod;